<div class="p-4">
  <h1>Encuesta cerrada</h1>
  <p>Por el momento se ha cerrado la posibilidad de responder esta encuesta. Por favor, esta atento a nuestros canales de comunicación para enterarte cuando se habilitará de nuevo.</p>

  <button (click)="goHome()">Volver</button>
</div>